const darkTheme = {
  global: {
    colors: {
      brand: '#db2327',
      control: '#db2327',
      red: '#db2327',
      green: '#26bf22',
      white: '#fff',
      whiteHover: 'rgba(255, 255, 255, 0.5)',
      bidColor: '#26bf22',
      askColor: '#db2327',
      background: '#120f22',
      primary: '#db2327',
      primaryHover: 'rgba(219, 35, 39, 0.5)',
      loadingColor: '#46B08E',
      focus: '#db2327',
      'background-1': '#120f22',
      'background-2': '#241f33',
      'background-3': '#312e3f',
      'background-4': '#42404f',
      'background-5': '#64626f',
      'background-6': '#000D14',
      'border-1': 'rgba(255,255,255,0.33)',
      handleColor: '#fff',
      defaultTextColor: '#f8f8f8',
      defaultTextColorDarken: '#d9d9d9',
      tableBackground: '#0A171E',
      tableHeadBackground: '#0A171E',
      selectBackground: '#231f33',
      errorPageBackground: '#fff',
      footerBackground: '#312e3f',
      navbarBackground: 'var(--navbar-background)',
      skinnyBarBackground: '#120f22',
      cookieConsentBackground: 'accent-4',

      'new-page-background': '#0A171E',
      'new-page-background-2': 'rgba(255, 255, 255, 0.1)',
      'new-page-background-3': 'rgba(255, 255, 255, 0.07)',
      'light-button': '#ffffff',
      'gray-button': '#7C817F',
      'font-color-gray': '#B4B6B7',
    },
    font: {
      size: '12px',
      lineHeight: '1.25',
      family: '"IBMPlexSans"',
      weight: 400,
    },
  },
  button: {
    border: {
      color: 'inherit',
      radius: '100px',
    },
    default: {
      background: {
        color: 'white',
      },
    },
    primary: {
      color: '#00080C',
    },
  },
  tab: {
    active: {
      color: 'brand',
    },
    color: 'text',
    border: {
      side: 'bottom',
      size: 'small',
      color: {
        dark: 'text',
        light: 'text',
      },
      active: {
        color: {
          dark: 'brand',
          light: 'brand',
        },
      },
      hover: {
        color: {
          dark: 'brand',
          light: 'brand',
        },
      },
    },
  },
  checkBox: {
    border: {
      color: 'rgba(255, 255, 255, 0.16)',
      width: '1px',
      radius: '6px',
    },
    check: {
      extend: ({ theme, checked }) =>
        `background-color: ${checked ? '#568677' : 'rgba(255, 255, 255, 0.1)'};
         border-color: ${checked ? '#568677' : 'rgba(255, 255, 255, 0.16)'};
         box-shadow: none;`,
    },
    icon: {
      size: '18px',
      extend: 'stroke: white;',
    },
    size: '20px',
  },
  chartingTheme: 'Dark',
  modalBackgroundColor: 'grey-lighter',
  modalConfirmationBackgroundColor: 'grey-darker',
  formButtonColor: 'primary',
};

const lightTheme = {
  global: {
    colors: {
      brand: '#db2327',
      red: '#db2327',
      green: '#26bf22',
      white: '#fff',
      whiteHover: 'rgba(255, 255, 255, 0.5)',
      bidColor: '#26bf22',
      askColor: '#db2327',
      background: '#eff2f6',
      primary: '#db2327',
      primaryHover: 'rgba(219, 35, 39, 0.5)',
      loadingColor: '#46B08E',
      'background-1': '#eff2f6',
      'background-2': '#fbfcfe',
      'background-3': '#ffffff',
      'background-4': '#eff2f6',
      'background-5': '#eff2f6',
      defaultTextColor: '#444444',
      defaultTextColorDarken: '#333333',
      'border-1': 'rgba(0,0,0,0.33)',
      handleColor: '#312e3f',
      tableBackground: '#fbfcfe',
      selectBackground: '#fbfcfe',
      errorPageBackground: '#fff',
      navbarBackground: '#312e3f',
      skinnyBarBackground: '#fbfcfe',
      footerBackground: '#312e3f',
      cookieConsentBackground: 'accent-4',
    },
    font: {
      size: '12px',
      lineHeight: '1.25',
      family: '"IBMPlexSans"',
      weight: 400,
    },
  },
  button: {
    border: {
      radius: '8px',
    },
  },
  tab: {
    active: {
      color: 'brand',
    },
    color: 'text',
    border: {
      side: 'bottom',
      size: 'small',
      color: {
        dark: 'text',
        light: 'text',
      },
      active: {
        color: {
          dark: 'brand',
          light: 'brand',
        },
      },
      hover: {
        color: {
          dark: 'brand',
          light: 'brand',
        },
      },
    },
  },
  chartingTheme: 'Light',
  modalBackgroundColor: 'grey-lighter',
  modalConfirmationBackgroundColor: 'grey-darker',
  formButtonColor: 'primary',
};

const themes = [
  {
    themeName: 'Dark',
    theme: darkTheme,
  },
  {
    themeName: 'Light',
    theme: lightTheme,
  },
];

window.themes = themes;

export default themes;
